export default "__VITE_ASSET__j5YHRnl7__"